import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mkt-desk",
  "use": "icon-soc-mkt-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mkt-desk\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M192 416h192l256-160v512L384 608H192V416z\" /><path d=\"M704 352c64 48 96 112 96 160s-32 112-96 160\" /><circle cx=\"768\" cy=\"256\" r=\"48\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mkt-desk.svg
// module id = MNaI
// module chunks = 546